import { Col, Row } from "react-bootstrap";
import PropTypes from "prop-types";

const LoginWrapper = ({
	children
}) => (
	<div className="py-md-4 container-xl px-sm-2 px-xl-0">
		<Row className="login-container justify-content-center align-items-center">
			<Col>
				{children}
			</Col>
		</Row>
	</div>
);

LoginWrapper.propTypes = {
	children: PropTypes.node.isRequired
};

export default LoginWrapper;
